import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST,
  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT,
  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD,
  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE,
  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET
} from '../actions';
import {
  EquipmentScheduleMaintenanceListSuccess,
  EquipmentScheduleMaintenanceListError,
  EquipmentScheduleMaintenanceSearchDeliveryOrderLineLotSuccess,
  EquipmentScheduleMaintenanceSearchDeliveryOrderLineLotError,
  EquipmentScheduleMaintenanceAddSuccess,
  EquipmentScheduleMaintenanceAddError,
  EquipmentScheduleMaintenanceDetailSuccess,
  EquipmentScheduleMaintenanceDetailError,
  EquipmentScheduleMaintenanceUpdateSuccess,
  EquipmentScheduleMaintenanceUpdateError,
  EquipmentScheduleMaintenanceUploadSetSuccess,
  EquipmentScheduleMaintenanceUploadSetError
} from '../actions';
 
export function* watchEquipmentScheduleMaintenanceList() {
  yield takeEvery(EQUIPMENT_SCHEDULE_MAINTENANCE_LIST, onEquipmentScheduleMaintenanceList);
}

export function* watchEquipmentScheduleMaintenanceSearchDeliveryOrderLineLot() {
  yield takeEvery(EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT, onEquipmentScheduleMaintenanceSearchDeliveryOrderLineLot);
}

export function* watchEquipmentScheduleMaintenanceAdd() {
  yield takeEvery(EQUIPMENT_SCHEDULE_MAINTENANCE_ADD, onEquipmentScheduleMaintenanceAdd);
}

export function* watchEquipmentScheduleMaintenanceDetail() {
  yield takeEvery(EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL, onEquipmentScheduleMaintenanceDetail);
}

export function* watchEquipmentScheduleMaintenanceUpdate() {
  yield takeEvery(EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE, onEquipmentScheduleMaintenanceUpdate);
}

export function* watchEquipmentScheduleMaintenanceUpload() {
  yield takeEvery(EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET, onEquipmentScheduleMaintenanceUpload);
}

const onEquipmentScheduleMaintenanceListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'equipment_schedule_maintenance/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentScheduleMaintenanceUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'equipment_schedule_maintenance/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEquipmentScheduleMaintenanceSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentScheduleMaintenanceAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'equipment_schedule_maintenance/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEquipmentScheduleMaintenanceDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'equipment_schedule_maintenance/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentScheduleMaintenanceUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/equipment_schedule_maintenance/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_equipment_schedule_maintenances/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_equipment_schedule_maintenances/'});
      });
    });
  });
};


function* onEquipmentScheduleMaintenanceList(data) {
  try {
    const response = yield call(onEquipmentScheduleMaintenanceListAsync, data.payload);
    yield put(EquipmentScheduleMaintenanceListSuccess(response.data));
  } catch (error) {
    yield put(EquipmentScheduleMaintenanceListError(error));
  }
}

function* onEquipmentScheduleMaintenanceSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onEquipmentScheduleMaintenanceSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(EquipmentScheduleMaintenanceSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(EquipmentScheduleMaintenanceSearchDeliveryOrderLineLotError(error));
  }
}

function* onEquipmentScheduleMaintenanceAdd(data) {
  try {
      const response = yield call(onEquipmentScheduleMaintenanceAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EquipmentScheduleMaintenanceAddSuccess(response.data));
  } catch (error) {
      yield put(EquipmentScheduleMaintenanceAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEquipmentScheduleMaintenanceDetail(data) {
  try {
    const response = yield call(onEquipmentScheduleMaintenanceDetailAsync, data.payload);
    yield put(EquipmentScheduleMaintenanceDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EquipmentScheduleMaintenanceDetailError(error));
  }
}

function* onEquipmentScheduleMaintenanceUpdate(data) {
  try {
      const response = yield call(onEquipmentScheduleMaintenanceUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EquipmentScheduleMaintenanceUpdateSuccess(response.data));
  } catch (error) {
      yield put(EquipmentScheduleMaintenanceUpdateError(error));
  }
}

function* onEquipmentScheduleMaintenanceUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onEquipmentScheduleMaintenanceUploadAsync, file);
    if(response.message ==='success'){
      yield put(EquipmentScheduleMaintenanceUploadSetSuccess(response));
    }
    else{
      yield put(EquipmentScheduleMaintenanceUploadSetError(response));
    }
  } catch (error) {
    yield put(EquipmentScheduleMaintenanceUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEquipmentScheduleMaintenanceList),
    fork(watchEquipmentScheduleMaintenanceSearchDeliveryOrderLineLot),
    fork(watchEquipmentScheduleMaintenanceAdd),
    fork(watchEquipmentScheduleMaintenanceDetail),
    fork(watchEquipmentScheduleMaintenanceUpdate),
    fork(watchEquipmentScheduleMaintenanceUpload),
  ]);
} 